import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { Student } from '../../models/student.model';
import { StudentService } from '../../services/student.service';

@Component({
    selector: 'app-student-summary-card',
    templateUrl: './student-summary-card.component.html',
    styleUrls: ['./student-summary-card.component.scss']
})
export class StudentSummaryCardComponent implements OnInit {

    @Input()  student: Student;

    @Output() onStudentStateChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private router: Router, private studentService: StudentService) { }

    ngOnInit() { }

    public getDNI(): string {
        return this.student.dni ? this.student.dni : 'Desconocido';
    }

    public getCurrentAge(): number {
        return moment().diff(this.student.birthDate, 'years');
    }

    public goToDetail(studentId: number) {

        var url = `participante/${studentId}/info`;
        this.router.navigate([url]);

    }

    public goToEdition(studentId: number) {

        var url = `participante/${studentId}/edicion`;
        this.router.navigate([url]);

    }

    public enable() {

        this.studentService.enable(this.student.studentId).subscribe({
            next: (result: boolean) => {
                this.onStudentStateChange.emit(result);
            }
        });

    }

    public disable() {

        this.studentService.delete(this.student.studentId).subscribe({
            next: (result: boolean) => {
                this.onStudentStateChange.emit(result);
            }
        });

    }

}
